import { render } from "./itemsAdd.vue?vue&type=template&id=248e17a6"
import script from "./itemsAdd.vue?vue&type=script&lang=js"
export * from "./itemsAdd.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__